(function() {

  angular
  .module('meanApp')
  .factory('Feature', Feature);

  Feature.$inject = ['$http', 'httpAuth', '$rootScope', 'Model'];
  function Feature ($http, httpAuth, $rootScope, Model) {
    var Feature = function (userData) {
        Model.apply(this, arguments);
    };

    Feature.APIPath = 'features';
    Feature.prototype = {
        getAPIPath: function() {
            return Feature.APIPath;
        }
    };
    
    angular.extend(Feature.prototype, Model.prototype);

    return Feature;
  };

})();